
import React from 'react';
import PlacesAutocomplete, { geocodeByAddress, getLatLng} from 'react-places-autocomplete';
import { classnames } from '../places_api_utils';

const defaultBounds = new window.google.maps.LatLngBounds(
  new window.google.maps.LatLng(33.419497251637985, -91.75625559120783),
  new window.google.maps.LatLng(36.84355854152846, -88.34170460879216)
);

const searchOptions = {
  // location,
  // radius: 200,
  // 'types': ['geocode', 'address', '(regions)', '(cities)'],
  bounds: defaultBounds,
  componentRestrictions: {
    country: 'us'
  },
  strictBounds: true
};

export default class PlacesSearchFilter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      address: this.props.listingFilter.searchStr,
      prevSearchId: this.props.searchId
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.searchId !== state.prevSearchId) {
      return {
        prevSearchId: props.searchId,
        address: ''
      };
    }
    return null;
  }

  handleSearchStrChange = (address) => {
    var updatedVal = address instanceof Object ? address.formattedSuggestion.mainText : address;

    this.setState({
      address: updatedVal
    // suggestion: null
    });
  };

  handleSelect = (suggestion) => {
    const validSuggestion = suggestion instanceof Object;
    if (!validSuggestion) return;
    this.setState({
      suggestion: suggestion,
      address: suggestion.formattedSuggestion.mainText,
      searchType: suggestion
    });

    var isZipCode = suggestion.types[0] == 'postal_code';
    var isCity = suggestion.types[0] == "locality";
    geocodeByAddress(suggestion.description)
      .then((results) => results[0])
      .then((result) => {
        const {address_components} = result;
        const googlePlacesType = address_components && address_components[0] && address_components[0].types[0];

        if (googlePlacesType == 'postal_code' || isZipCode) {
          this.props.updateFilter({
            searchStr: '',
            city: '',
            zipCode: suggestion.formattedSuggestion.mainText,
            searchLocType: '',
            searchLoc: '',

          });
        } else if (isCity) {
          this.props.updateFilter({
            searchStr: '',
            city: suggestion.formattedSuggestion.mainText,
            zipCode: '',
            searchLocType: '',
            searchLoc: ''
          });
        } else {
          const searchLocType = googlePlacesType;
          const searchLoc = "" + result.geometry.location.lat() + "," + result.geometry.location.lng();
          this.props.updateFilter({
            searchStr: suggestion.description,
            city: '',
            zipCode: '',
            searchLocType,
            searchLoc,
            status: ['ACT', 'PEND', 'CNTG']
          });
        }
      });
  }

  handleOnBlur = (e) => {
    if (!this.state.suggestion) {
      this.setState({
        address: ''
      })
    }
    if (this.state.address === '') {
      this.props.updateFilter({
        searchStr: '',
        city: '',
        zipCode: '',
        searchLocType: '',
        searchLoc: ''
      });
    }

  }

  handlePlaceSelect = (address) => {
    // Check if address is valid
    if (address) {
      // Set State
      this.setState({
        address,
        suggestion: null
      });
    }
  }

  updateSearchStr = (address) => {
    var updatedVal = address instanceof Object ? address.formattedSuggestion.mainText : address;

    this.setState({
      address: updatedVal
    });
  }


  render() {
    const {classes, listing} = this.props;
    return (
      <PlacesAutocomplete value={ this.state.address || '' } onChange={ this.updateSearchStr } onKeyPress={ (e) => {
                                                                                                        console.log('key press')
                                                                                                        e.key === 'Enter' && e.preventDefault();
                                                                                                      } } onSelect={ this.handleSelect } searchOptions={ searchOptions }>
        { ({getInputProps, suggestions, getSuggestionItemProps, loading}) => (
            <div>
              <input {...getInputProps()} type="text" placeholder="Address, City or Zip" className="form-control py-2 border-right-0 border" onBlur={ this.handleOnBlur } />
              <div>
                { suggestions.map(suggestion => {
                    const className = classnames('Demo__suggestion-item', {
                      'Demo__suggestion-item--active': suggestion.active,
                    });

                    return (
                      /* eslint-disable react/jsx-key */
                      <div {...getSuggestionItemProps(suggestion, { className })}>
                        <strong> { suggestion.formattedSuggestion.mainText } </strong>
                        { ' ' } <small> { suggestion.formattedSuggestion.secondaryText }</small></div>
                      );

                  }) }
              </div>
            </div>
          ) }
      </PlacesAutocomplete>
      );
  }
}
